(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sisiyuyu-product-media-overlay"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sisi-product-media-overlay')) {
    customElements.define('sisi-product-media-overlay', class extends HTMLElement {
      connectedCallback() {
        const closeButton = this.querySelector('[data-sisi-overlay-close]');
        const card = this.querySelector('[data-sisi-overlay-card]');
        if (!closeButton || !card) return;
        closeButton.addEventListener('click', () => {
          card.hidden = true;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
